module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/download.worker.a1d7d73d94d585ff1802.js");
}
